import { render, staticRenderFns } from "./Resumen_Diario.vue?vue&type=template&id=4af36579"
import script from "./Resumen_Diario.vue?vue&type=script&lang=js"
export * from "./Resumen_Diario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports